module.exports = __webpack_public_path__ + "img/icon (1).e735df16.png";